import React from "react";
// component
import Loading from "../../../../components/childrens/loading/loading.tsx";
import Delete from "../../../../components/basement/admin/delete/delete.tsx";
// icons
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { Link } from "react-router-dom";
// controller
import { PhotographerList } from "../../../../controllers/admin/photographer/photographerList.tsx";

const UserPhotographer = () => {
    const { id, title, items, isLoading, changeData, onDelete, fileterUser, changeStatus } = PhotographerList();
    return (
        <>
            <section>
                {/* admin page component */}
                <div className={'admin-page-content mb-3 pt-0'}>
                    <div id={'admin-page-form'}>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <p className={'fw-bold box-title mb-0'}>عکاسان</p>
                            <Link to={'/dashboard/admin/user/photographer/create'} className="btn btn-outline-primary py-1">
                                ایجاد عکاس
                            </Link>
                        </div>
                        <div className={'card card-body shadow border-0'}>
                            {!isLoading ?
                                (
                                    <>
                                        <div className="fliter">
                                            <div className="filter-form">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <fieldset className="form-floating">
                                                            <select className="form-select" onChange={fileterUser}>
                                                                <option value={'active'}>فعال</option>
                                                                <option value={'inactive'}>غیرفعال</option>
                                                                <option value={'banned'}>بن شده</option>
                                                            </select>
                                                            <label className="form-label">
                                                                فیلتر براساس
                                                            </label>
                                                        </fieldset>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive mt-4">
                                            <table className="table text-center align-middle font-medium">
                                                <thead>
                                                    <tr>
                                                        <th>ردیف</th>
                                                        <th>نام و نام خانوادگی</th>
                                                        <th>شماره همراه</th>
                                                        <th>کد ملی</th>
                                                        <th>ایمیل</th>
                                                        <th>وضعیت</th>
                                                        <th>عملیات</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {items?.map((photographer: any, index: number) => (
                                                        <tr key={photographer.full_name}>
                                                            <td>
                                                                {index + 1}
                                                            </td>
                                                            <td>
                                                                {photographer.full_name ? photographer.full_name : 'خالی'}
                                                            </td>
                                                            <td>
                                                                {photographer.cellphone ? photographer.cellphone : 'خالی'}
                                                            </td>
                                                            <td>
                                                                {photographer.national_code ? photographer.national_code : 'خالی'}
                                                            </td>
                                                            <td>
                                                                {photographer.email ? photographer.email : 'خالی'}
                                                            </td>
                                                            <td>
                                                                <select className="form-select" defaultValue={photographer.status} onChange={(e) => changeStatus(e, photographer.id)}>
                                                                    <option value={"1"}>فعال</option>
                                                                    <option value={"0"}>غیرفعال</option>
                                                                    <option value={"2"}>بن شده</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <Link to={`/dashboard/admin/user/photographer/update/${photographer.id}`}>
                                                                    <IconEdit className="mx-1 text-primary" size={16} />
                                                                </Link>
                                                                <IconTrash data-bs-toggle="modal" data-bs-target="#delete-modal" onClick={() => changeData(photographer.id, photographer.full_name ? photographer.full_name : 'مشاور')} className="text-danger" size={16} />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <Delete id={id} title={title} function={() => onDelete(id)} />
                                    </>
                                )
                                :
                                (
                                    <>
                                        <Loading />
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default UserPhotographer;